import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import NotFound from '../blogs/utils/NotFound';

export const slugToFileName = (slug) => {
    return slug
        .split('-')
        .map((word) => {
            if (/^[0-9]+$/.test(word)) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('') + '.js';
};

const ToolWrapper = () => {
    const { toolId } = useParams();

    const ToolComponent = useMemo(() => {
        const context = require.context('./', false, /\.js$/);
        const fileName = slugToFileName(toolId);

        try {
            // Find the matching file in the context
            const path = context.keys().find(path =>
                path === `./${fileName}` ||
                path.toLowerCase() === `./${fileName.toLowerCase()}`
            );

            if (!path) {
                return null;
            }

            const module = context(path);
            return module.default;
        } catch (error) {
            console.error('Tool loading error:', error);
            return null;
        }
    }, [toolId]);

    if (!ToolComponent) {
        return <NotFound />;
    }

    return <ToolComponent />;
};

export default ToolWrapper;
